import { getDataMapper, mapField } from "@/shared";

export const mapRepairServiceToServer = getDataMapper(
    {
        service_id: mapField("service", (s) => s.service.id),
        inventory_id: mapField("inventory", (i) => i.id),
    },
    { shouldAvoidUndefined: true }
);
